<template>
  <v-container fluid v-bind:class="{'pt-0':currentUser.clientType === 'Media'}" >
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-card elevation="0" outlined :loading="loading">
          <v-card-title class="monospace-font" style="font-size: 16px;">{{`${currentUser.clientName} · ${$t('homeStats.data')}`}}</v-card-title>
          <v-divider class="mx-4"></v-divider>
            <v-row v-if="!loading && driblabStats" :justify="$vuetify.breakpoint.mdAndDown ? 'start' : 'space-around'" class="py-3">
              <!--Players-->
              <v-col :cols="numOfCols" class="m-1 ml-5 mr-1 d-flex flex-row" v-bind:class="{'align-start': $vuetify.breakpoint.mdAndDown, 'align-center': $vuetify.breakpoint.lgAndUp}">
                <div class="secondary pa-2 mr-3 rounded-lg" v-bind:class="{'ml-3 mr-1': isRtl}"><v-icon color="white" :large="$vuetify.breakpoint.lgAndUp">directions_run</v-icon></div>
                <div class="d-flex flex-column">
                  <p v-if="userPlayers && clientStats" class="mb-1 primary--text body-1">{{(clientPlayers)}} {{$t('homeStats.players')}}</p>
                  <v-skeleton-loader v-else type="text" class="mb-2"></v-skeleton-loader>
                  <span class="subheader-font body-2">{{driblabStats.dP}} {{$t('homeStats.totalPlayers')}}</span>
                </div>
              </v-col>
              <!--Teams-->
              <v-col :cols="numOfCols" class="m-1 ml-5 mr-1 d-flex flex-row" v-bind:class="{'align-start': $vuetify.breakpoint.mdAndDown, 'align-center': $vuetify.breakpoint.lgAndUp}">
                <div class="secondary pa-2 mr-3 rounded-lg" v-bind:class="{'ml-3 mr-1': isRtl}"><v-icon color="white" :large="$vuetify.breakpoint.lgAndUp">shield</v-icon></div>
                <div class="d-flex flex-column">
                  <p v-if="userPlayers && clientStats"  class="mb-1 primary--text body-1">{{clientTeams}} {{$t('homeStats.teams')}}</p>
                  <v-skeleton-loader v-else type="text" class="mb-2"></v-skeleton-loader>
                  <span class="subheader-font body-2">{{driblabStats.dT}} {{$t('homeStats.totalTeams')}}</span>
                </div>
              </v-col>
              <!--Leagues-->
              <v-col :cols="numOfCols" class="m-1 ml-5 mr-1 d-flex flex-row" v-bind:class="{'align-start': $vuetify.breakpoint.mdAndDown, 'align-center': $vuetify.breakpoint.lgAndUp}">
                <div class="secondary pa-2 mr-3 rounded-lg" v-bind:class="{'ml-3 mr-1': isRtl}"><v-icon color="white" :large="$vuetify.breakpoint.lgAndUp">emoji_events</v-icon></div>
                <div class="d-flex flex-column">
                  <p v-if="userPlayers && clientStats" class="mb-1 primary--text body-1">{{(clientLeagues)}} {{$t('homeStats.leagues')}}</p>
                  <v-skeleton-loader v-else type="text" class="mb-2"></v-skeleton-loader>
                  <span class="subheader-font body-2">{{driblabStats.dL}} {{$t('homeStats.totalLeagues')}}</span>
                </div>
              </v-col>
              <!--Seasons-->
              <v-col :cols="numOfCols" class="m-1 ml-5 mr-1 d-flex flex-row" v-bind:class="{'align-start': $vuetify.breakpoint.mdAndDown, 'align-center': $vuetify.breakpoint.lgAndUp}">
                <div class="secondary pa-2 mr-3 rounded-lg" v-bind:class="{'ml-3 mr-1': isRtl}"><v-icon color="white" :large="$vuetify.breakpoint.lgAndUp">timelapse</v-icon></div>
                <div class="d-flex flex-column">
                  <p v-if="userPlayers && clientStats" class="mb-1 primary--text body-1">{{(clientSeasons)}} {{$t('homeStats.seasons')}}</p>
                  <v-skeleton-loader v-else type="text" class="mb-2"></v-skeleton-loader>
                  <span class="subheader-font body-2">{{driblabStats.dS}} {{$t('homeStats.totalSeasons')}}</span>
                </div>
              </v-col>
              <!--Games-->
              <v-col :cols="numOfCols" class="m-1 ml-5 mr-1 d-flex flex-row" v-bind:class="{'align-start': $vuetify.breakpoint.mdAndDown, 'align-center': $vuetify.breakpoint.lgAndUp}">
                <div class="secondary pa-2 mr-3 rounded-lg" v-bind:class="{'ml-3 mr-1': isRtl}"><v-icon color="white" :large="$vuetify.breakpoint.lgAndUp">sports_soccer</v-icon></div>
                <div class="d-flex flex-column">
                  <p v-if="userPlayers && clientStats" class="mb-1 primary--text body-1">{{(clientGames)}} {{$t('homeStats.games')}}</p>
                  <v-skeleton-loader v-else type="text" class="mb-2"></v-skeleton-loader>
                  <span class="subheader-font body-2">{{driblabStats.dG}} {{$t('homeStats.totalGames')}}</span>
                </div>
              </v-col>
            </v-row>
            <!--Loading data progress circle-->
            <v-row v-if="loading" justify="center" class="pb-3">
              <v-col cols="auto">
                <v-progress-circular :size="75" color="secondary" indeterminate></v-progress-circular>
              </v-col>
            </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row >
      <v-col cols="12" v-if="currentUser.clientType != 'Driblab' && currentUser.clientType != 'Media'">
        <ScoutDashboard v-if="currentUser.userType === 'Scout'"></ScoutDashboard>
        <CoachDashboard v-if="currentUser.userType === 'Coach'"></CoachDashboard>
        <OwnerDashboard v-if="currentUser.userType === 'Ownership'"></OwnerDashboard>
        <SportingDirectorDashboard v-if="currentUser.userType === 'SportingDirector'"></SportingDirectorDashboard>

        <IndividualDashboard v-if="currentUser.userType === 'Individual'"></IndividualDashboard>
        <BrandDashboard v-if="currentUser.userType === 'Brand'"></BrandDashboard>
        <AgencyDashboard v-if="currentUser.userType === 'Agency'"></AgencyDashboard>
        <FederationDashboard v-if="currentUser.userType === 'Federation'"></FederationDashboard>
      </v-col>
      <v-col cols="12" class="pt-0" v-if="currentUser.clientType === 'Media'">
        <IndividualDashboard></IndividualDashboard>
      </v-col>
      <v-col cols="12" class="" v-if="currentUser.clientType === 'Driblab'" >
        <DriblabDashboard></DriblabDashboard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AgencyDashboard from "./dashboard/AgencyDashboard";
import BrandDashboard from "./dashboard/BrandDashboard";
import CoachDashboard from "./dashboard/CoachDashboard";
import FederationDashboard from "./dashboard/FederationDashboard";
import IndividualDashboard from "./dashboard/IndividualDashboard";
import MediaDashboard from "./dashboard/MediaDashboard";
import OwnerDashboard from "./dashboard/OwnerDashboard";
import ScoutDashboard from "./dashboard/ScoutDashboard";
import SportingDirectorDashboard from "./dashboard/SportingDirectorDashboard";
import DriblabDashboard from './dashboard/DriblabDashboard';
import StatService from '../services/stat.service';

export default {
  name: "Home",
  components: {
    AgencyDashboard,
    BrandDashboard,
    CoachDashboard,
    FederationDashboard,
    IndividualDashboard,
    MediaDashboard,
    OwnerDashboard,
    ScoutDashboard,
    SportingDirectorDashboard,
    DriblabDashboard
  },
  title () {
    return this.$t('dashboards.title');
  },
  data() {
    return {
      overrideWindowTitle: true,
      content: "",
      loading: false,
      clientStats: null,
      userPlayers: null,
      driblabStats: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    clientPlayers() {
      //If client players is bigger than driblab total, return total
      if (this.userPlayers && this.driblabStats) return this.userPlayers > this.driblabStats.dP ? this.driblabStats.dP : this.userPlayers;
    },
    clientTeams() {
       //If client teams is bigger than driblab total, return total
      if (this.clientStats && this.driblabStats) return this.clientStats.cT > this.driblabStats.dT ? this.driblabStats.dT : this.clientStats.cT;
    },
    clientLeagues() {
       //If client leagues is bigger than driblab total, return total
      if (this.clientStats && this.driblabStats) return this.clientStats.cL > this.driblabStats.dL ? this.driblabStats.dL : this.clientStats.cL;
    },
    clientSeasons() {
       //If client seasons is bigger than driblab total, return total
      if (this.clientStats && this.driblabStats) return this.clientStats.cS > this.driblabStats.dS ? this.driblabStats.dS : this.clientStats.cS;
    },
    clientGames() {
       //If client games is bigger than driblab total, return total
      if (this.clientStats && this.driblabStats) return this.clientStats.cG > this.driblabStats.dG ? this.driblabStats.dG : this.clientStats.cG;
    },
    currentUserLanguage() {
      return this.$store.getters["auth/language"];
    },
    isRtl(){
      return this.currentUserLanguage === 'sa'
    },
    numOfCols() {
      if (this.$vuetify.breakpoint.xsOnly) return 12;
      else if (this.$vuetify.breakpoint.mdAndDown) return 3;
      else return 2;
    }
  },
  mounted() {
    this.getHistoryStats();
    this.getClientPlayers();
    this.getOverallStats();
  },
  methods: {
    async getHistoryStats() {
      this.loading = true;
      const response = await StatService.getHistoryStats();
      this.driblabStats = response.data;
      this.loading = false;
    },
    async getClientPlayers() {
      const response = await StatService.getClientOverallPlayersStats(this.currentUser.clientId);
      this.userPlayers = response.data;
    },
    async getOverallStats() {
      const response = await StatService.getClientOverallStats(this.currentUser.clientId);
      this.clientStats = response.data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue